<template>
  <router-link
    v-if="canViewLink"
    :to="{ name: page.name, params: page.params }"
  >
    <div
      class="relative my-3 group flex items-center px-8 text-base leading-5 font-medium text-white focus:outline-none transition ease-in-out duration-150 hover:bg-indigo-700"
      :class="{
        'bg-indigo-700 border-r-2 border-pink-600':
          currentPage === page.link ||
          (page.link != '/' &&
            currentPage.includes('cartographies/collectives') &&
            currentPage.includes(page.link)),
        'justify-center': !isFullMenu && !isOpen,
      }"
    >
      <div
        class="p-4 h-full"
        :class="{
          'border-pink-600 border rounded-lg':
            currentPage === page.link ||
            (page.link != '/' &&
              currentPage.includes('cartographies/collectives') &&
              currentPage.includes(page.link)),
        }"
      >
        <icon
          :name="page.icon"
          class="h-5 w-5 text-gray-300 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
        />
      </div>
      <p
        class="ml-4 pt-1"
        v-if="isFullMenu || isOpen"
      >
        {{ page.libelle }}
      </p>
      <beta-tag
        v-if="page.link === 'competences'"
        :class="isFullMenu ? '' : 'absolute transform scale-75 top-0'"
      />
    </div>
  </router-link>
</template>

<script>
import Icon from './Icon';
import Constants from './../constants';
import BetaTag from './BetaTag.vue';

export default {
  name: 'MenuLinkMobile',
  components: { Icon, BetaTag },
  props: {
    page: {
      type: Object,
      required: true,
    },
    currentPage: {
      type: String,
      required: true,
    },
    isFullMenu: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    canViewLink() {
      const canSeeDashboard =
        this.page.name === 'Dashboard' &&
        this.$store.getters['auth/role'] !== Constants.ROLE_BENEFICIAIRE;
      return (
        !this.page.permission_name_read ||
        this.$can(page.permission_name_read) ||
        canSeeDashboard
      );
    },
  },
};
</script>

<style scoped></style>
